import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, toHandlers as _toHandlers, mergeProps as _mergeProps, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "relative flex" }

import { computed } from 'vue'
import { DatePicker } from 'v-calendar'
import { CalendarIcon } from '@klausapp/ui-kit/icons'
import { UiInput } from '@klausapp/ui-kit'

import { formatDateIntl, maxFourDigitYearDate } from '@/utils/date'
import { session } from '@/composables/useSession'
import { dayPickerAttributes, firstDayOfWeek } from '@/styles/v-calendar'

type DateType = string | Date


export default /*@__PURE__*/_defineComponent({
  __name: 'DayPicker',
  props: {
    label: {},
    modelValue: {},
    minDate: {},
    maxDate: { default: () => maxFourDigitYearDate },
    dateFormat: { default: () => ({ dateStyle: 'medium' }) as Intl.DateTimeFormatOptions },
    small: { type: Boolean },
    placeholder: {},
    required: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any) {

const props = __props



const dateValue = computed(() => {
  if (props.minDate && new Date(props.minDate as DateType) > new Date(props.modelValue as DateType))
    return props.minDate
  return props.modelValue
})

const userLocale = computed(() => session.user.locale.split('-')[0])

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DatePicker), _mergeProps(_ctx.$attrs, {
    color: "brand",
    "model-value": dateValue.value,
    "first-day-of-week": _unref(firstDayOfWeek),
    locale: userLocale.value,
    attributes: _unref(dayPickerAttributes),
    masks: { weekdays: 'WW', input: 'YYYY-MM-DD' },
    "min-date": _ctx.minDate,
    "max-date": _ctx.maxDate,
    popover: { visibility: 'click', modifiers: [{ name: 'preventOverflow', options: { mainAxis: false } }] },
    "is-required": _ctx.required,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event))),
    onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
  }), {
    default: _withCtx(({ inputValue, inputEvents: { input, ...inputEvents } }) => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(CalendarIcon), {
          class: _normalizeClass(["icon-m absolute left-3 top-3 stroke-gray-50", {
            '!top-2': _ctx.small,
          }])
        }, null, 8 /* PROPS */, ["class"]),
        _createVNode(_unref(UiInput), _mergeProps({
          class: "pl-9",
          small: _ctx.small,
          "model-value": inputValue && _unref(formatDateIntl)(inputValue.concat(' ', '00:00:00'), _ctx.dateFormat),
          placeholder: _ctx.placeholder,
          "onUpdate:modelValue": input
        }, _toHandlers(inputEvents)), null, 16 /* FULL_PROPS */, ["small", "model-value", "placeholder", "onUpdate:modelValue"])
      ])
    ]),
    _: 1 /* STABLE */
  }, 16 /* FULL_PROPS */, ["model-value", "first-day-of-week", "locale", "attributes", "min-date", "max-date", "is-required"]))
}
}

})